import React from "react";
import {
  findVehicle,
  getTruckImage,
  cleanTruckLabel,
  capacityLabel,
} from "./helpers";

/** Compact vehicle recap shown at the top of the final booking step. */
const BookingVehicleSummary = ({
  truckType,
  vehicletypes = [],
  tripDistance = 0,
  tripDuration = 0,
  quotedRunners = 0,
  quotedFloors = 0,
}) => {
  if (!truckType) return null;

  const vehicle = findVehicle(vehicletypes, truckType);
  const name = vehicle?.loadgroup || cleanTruckLabel(truckType);
  const capacity = capacityLabel(vehicle?.tonnes);
  const body = (vehicle?.bodylabel || "").replace(/\s*body$/i, "").trim();
  const vehicleMeta = [capacity, body && `${body} body`]
    .filter(Boolean)
    .join(" · ");

  const tripParts = [];
  if (tripDistance > 0) {
    tripParts.push(`${Math.round(tripDistance / 1000)} km`);
  }
  if (tripDuration > 0) {
    tripParts.push(`${Math.round(tripDuration / 60)} min`);
  }
  if (quotedRunners > 0) {
    tripParts.push(
      `${quotedRunners} helper${quotedRunners === 1 ? "" : "s"}`,
    );
  }
  if (quotedFloors > 0) {
    tripParts.push(`${quotedFloors} floor${quotedFloors === 1 ? "" : "s"}`);
  }

  return (
    <div className="lp2-booking-vehicle" aria-label="Booked vehicle">
      <img
        className="lp2-booking-vehicle-img"
        src={getTruckImage(truckType)}
        alt=""
        loading="lazy"
        aria-hidden="true"
      />
      <div className="lp2-booking-vehicle-text">
        <span className="lp2-booking-vehicle-name">{name}</span>
        {vehicleMeta ? (
          <span className="lp2-booking-vehicle-meta">{vehicleMeta}</span>
        ) : null}
        {tripParts.length > 0 ? (
          <span className="lp2-booking-vehicle-trip">{tripParts.join(" · ")}</span>
        ) : null}
      </div>
    </div>
  );
};

export default BookingVehicleSummary;
